import React from 'react';
import clsx from 'clsx';

import { Row, T8y } from 'ui';

import style from './productBlock.module.scss';

const ProductBlock = ({ title, children, classNameWrapper, noCamel }) => {
  return (
    <Row
      className={clsx(style.productBlockWrapper, classNameWrapper)}
      direction="column"
    >
      {!!title && (
        <T8y
          variant="h1v1"
          className={style.productCommonTitle}
          data-testid={`product-block-title-${title}`}
          capitalize={!noCamel}
          fullWidth
          mb2
        >
          {title}
        </T8y>
      )}
      {children}
    </Row>
  );
};

export default ProductBlock;
